import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';

const NoData = ({ schema, noDataText }) => {
  let content = (
    <div className="no-data">
      <Translate value={'common.table.NO_DATA'} />
    </div>
  );
  if (noDataText) {
    content = <div className="no-data-text">{noDataText}</div>;
  }
  return (
    <tbody>
      <tr>
        <td colSpan={schema.length}>{content}</td>
      </tr>
    </tbody>
  );
};

NoData.propTypes = {
  schema: PropTypes.array.isRequired,
  noDataText: PropTypes.string.isRequired,
};

export default NoData;
